export const OfflineText = {
    title: {
        en: "No Internet Connection",
        mr: "इंटरनेट कनेक्शन नाही",
    },
    description: {
        en: "It looks like you're offline. Please check your internet connection and try again.",
        mr: "असे दिसते की आप ऑफलाइन आहात. कृपया आपले इंटरनेट कनेक्शन तपासा आणि पुन्हा प्रयत्न करा.",
    },
    button: {
        en: "Retry",
        mr: "पुन्हा प्रयत्न करा",
    },
};
